import { render, staticRenderFns } from "./RoutineDetail.vue?vue&type=template&id=3c67014e&scoped=true"
import script from "./RoutineDetail.vue?vue&type=script&lang=js"
export * from "./RoutineDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67014e",
  null
  
)

export default component.exports